import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaAppBar from './VaAppBar.vue'

export const VaAppBar = withConfigTransport(_VaAppBar)
